// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"245":"bonusgame","826":"index"}[chunkId] || chunkId) + "." + {"245":"38c55192","272":"ea6707b9","826":"7b9219f7"}[chunkId] + ".css";
};